<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="客户">
      {{ head.customer.customerNo + " " + head.customer.name }}
    </el-descriptions-item>
    <el-descriptions-item label="定制单" span="2">
      {{ head.relatedCustomizeOrderHead.orderNo }}
    </el-descriptions-item>
    <el-descriptions-item label="供应商" span="3">
      {{ head.supplier.name }}
    </el-descriptions-item>
    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="500px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="60"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品信息"
          min-width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="max-width: 300px">
                  <p>
                    商品名称：{{
                      scope.row.relatedCustomizeOrderItem.commodityName
                    }}
                  </p>
                  <p class="fm-mt-5">
                    备注：
                    <span
                      v-fmtype="
                        scope.row.relatedCustomizeOrderItem.remark
                          ? ''
                          : 'warning'
                      "
                      >{{
                        scope.row.relatedCustomizeOrderItem.remark || "——"
                      }}</span
                    >
                  </p>
                </div>
                <div>
                  <p class="fm-line-2">
                    商品名称：{{
                      scope.row.relatedCustomizeOrderItem.commodityName
                    }}
                  </p>
                  <p class="fm-line-2 fm-mt-5">
                    备注：
                    <span
                      v-fmtype="
                        scope.row.relatedCustomizeOrderItem.remark
                          ? ''
                          : 'warning'
                      "
                      >{{
                        scope.row.relatedCustomizeOrderItem.remark || "——"
                      }}</span
                    >
                  </p>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="相关图片"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.relatedCustomizeOrderItem.fileList &&
                scope.row.relatedCustomizeOrderItem.fileList.length > 0
              "
            >
              <el-image
                v-for="(item, index) in scope.row.relatedCustomizeOrderItem
                  .fileList"
                :key="index"
                :style="{
                  width: '45px',
                  height: '45px',
                  'border-radius': '5px',
                  border: '1px solid var(--fm-border-color)',
                  'margin-left': '5px',
                }"
                fit="cover"
                :preview-src-list="
                  scope.row.relatedCustomizeOrderItem.fileList.map(
                    (d) => d.sysFile.prefix + d.sysFile.name
                  )
                "
                :src="item.sysFile.prefix + item.sysFile.name"
              ></el-image>
            </div>
            <div class="fm-center" v-else>
              <p v-fmtype="'warning'">暂未上传</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="retailPrice"
          label="商品采购价"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.retailPrice"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="数量"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.itemQuantity + scope.row.relatedCustomizeOrderItem.unit
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="itemAmount"
          label="金额"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              总采购价：
              <FmAmount
                :amount="scope.row.commodityRetailTotalAmount"
              ></FmAmount>
            </div>
            <div class="fm-flex">
              折扣金额：<FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </div>
            <div class="fm-flex">
              成交价：<FmAmount :amount="scope.row.itemAmount"></FmAmount>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="itemQuantity"
          label="入库进度"
          width="150"
          align="left"
          header-align="center"
          v-if="head.orderApprovalStatusEnum.Name == 'Approval'"
        >
          <template slot-scope="scope">
            {{ "待入库 " + scope.row.toBeInputQuantity }}<br />
            {{
              "入库中 " +
              scope.row.inputingQuantity +
              " , 已入库 " +
              scope.row.completedInputQuantity
            }}<br />
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>

    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （总采购价：<FmAmount
          :amount="head.commodityRetailTotalAmount"
        ></FmAmount
        >，优惠金额：<FmAmount
          :amount="head.commodityRetailDisCountAmount"
        ></FmAmount
        >）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="纸质单据" span="3">
      <OrderImageList
        :list="head.paperOrderImageList"
        name="纸质单据图片"
      ></OrderImageList>
    </el-descriptions-item>

    <el-descriptions-item label="付款进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          付款进度：
          <span
            v-fmtype="$jsTool.getFundPayProgressType(head.fundPayProgressEnum)"
          >
            {{ head.fundPayProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">
          待付：<FmAmount :amount="head.toBePayAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          付款中：<FmAmount :amount="head.payingAmount"></FmAmount
          >，已付款：<FmAmount :amount="head.completedPayAmount"></FmAmount
          >，付款优惠：<FmAmount :amount="head.payDisCountAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          全部付款时间：<span v-fmtype="head.fullPayTime ? '' : 'warning'">{{
            head.fullPayTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="入库进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          入库进度：
          <span
            v-fmtype="
              $jsTool.getCommodityInputProgressType(
                head.commodityInputProgressEnum
              )
            "
          >
            {{ head.commodityInputProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">待入库：{{ head.toBeInputQuantity }}</div>
        <div class="fm-flex">
          入库中：{{ head.inputingQuantity }}，已入库：{{
            head.completedInputQuantity
          }}
        </div>
        <div class="fm-flex">
          全部入库时间：<span v-fmtype="head.fullInputTime ? '' : 'warning'">{{
            head.fullInputTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="3">
      {{ head.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="拓展字段" span="3">
      <div v-if="head.extFieldValueList && head.extFieldValueList.length > 0">
        <div v-for="(item, index) in head.extFieldValueList" :key="index">
          {{
            item.label + "：" + (item.value == null ? "-" : item.value) + ";"
          }}
        </div>
      </div>
      <div v-fmtype="'warning'" v-else>—</div>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizePurchaseOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.head
        ? this.showOrderInfo.head
        : {};
    },
    itemList() {
      if (this.showOrderInfo && this.showOrderInfo.itemList) {
        return this.showOrderInfo.itemList;
      }
      return [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CustomizePurchaseOrder:NeedApproval",
        "Order:CustomizePurchaseOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizePurchaseOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizePurchaseOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.customizePurchaseOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CustomizePurchaseOrderInfo.vue